import React, { useEffect, forwardRef } from 'react';
import styles from './ModalInner.module.scss';

const ModalInner = forwardRef((props, ref) => {
    const {
        isVisible,
        width,
        minWidth,
        maxWidth,
        overflow,
        textAlign,
        closeModal,
        shouldCloseOnOutSideClick,
        contentPadding: padding,
        children,
    } = props;

    const handleClickOutside = event => {
        if (ref.current && !ref.current.contains(event.target)) {
            closeModal();
        }
    };

    useEffect(() => {
        if (isVisible) {
            document.getElementById('app-container').style.filter = 'blur(16px)';
            shouldCloseOnOutSideClick &&
                document.addEventListener('click', handleClickOutside, true);
        }
        return () => {
            document.getElementById('app-container').style.filter = 'blur(0)';
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [isVisible]);

    return (
        <div className={`${styles.modal} ${!isVisible ? 'd-hidden' : ''}`}>
            <div
                className={styles.modalContent}
                ref={ref}
                style={{
                    width,
                    minWidth,
                    maxWidth,
                    textAlign,
                    padding,
                    overflow,
                }}
            >
                {children}
            </div>
        </div>
    );
});

ModalInner.defaultProps = {
    shouldCloseOnOutSideClick: false,
};

export default ModalInner;
